import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Spinner
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
import { postSubmitForm } from "../../../../helpers/forms_helper";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import showNotification from "../../../../helpers/show_notification";
import EnterQuantityForManualInventory from "../../../../components/EnterQuantityForManualInventory";
import UpdateQuantityForManualInventory from "../../../../components/UpdateQuantityForManualInventory";
const animatedComponents = makeAnimated();

const AddOpeningComp = (props) => {
  useEffect(() => {
    loadAllProduct();
    if (props.selectedProduct) {
      setSelectedProduct(props.selectedProduct);
      setSelectUnitModal(true)
    }
  }, []);
  const refContainer = useRef(null);
  const refSelectProduct = useRef(null);
  let store_id = localStorage.getItem("store_id")

  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      if(!selectedProduct.quantity){
        showNotification("Please enter a valid quantity","Warning")
        return
      }
      // else if (selectedProduct.quantity && selectedProduct.quantity.every(({ value }) => (value == "0" || value == 0 || value === ""))) {
      //   showNotification("Please enter a valid quantity for at least one unit","Warning");
      //   return;
      // }
      let data_to_send = {};
      data_to_send.store_id = store_id;
      data_to_send.product_id = selectedProduct.product_id;
      data_to_send.quantity = selectedProduct.quantity.map(({unit,value})=>({unit,value}));
      // data_to_send.expiry_date = v.expiry_date;
      data_to_send.cost_price = +v.cost_price;
      data_to_send.selling_price = +v.selling_price;

      // console.log(data_to_send);return
      setIsDisabled(true)
      let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/product_manual_entry";
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        setIsDisabled(false)
        showNotification(response.message, "Success");
        refSelectProduct.current.select.clearValue();
        refContainer.current.reset();
        if (props.isRefreshData) {
          props.refreshData();
          props.handleClosePopup();
        }
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error, "Error");
    }
  };

  const [allProducts, setAllProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const loadAllProduct = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchproducts/getforbranch";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllProducts(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [selectUnitModal, setSelectUnitModal] = useState(false)
  function handleSelectProduct (selected) {
    setSelectedProduct(selected)
    setSelectUnitModal(!selectUnitModal)
  }

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [editUnitModal, setEditUnitModal] = useState(false);


function handleToggle() {
    setSelectUnitModal(false);
    setEditUnitModal(false)
    setSelectedRowsUnit([])

}
function handleAddQuantity(quantity) {
        const updatedProd = { ...selectedProduct };
          let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
          updatedProd.quantity=convertedQuantity
        setSelectedProduct(updatedProd);
        setSelectUnitModal(false);
}
const handleUpdateQuantity = (quantity) => {
  const updatedProd = { ...selectedProduct };
  let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
  updatedProd.quantity=convertedQuantity
    setSelectedProduct(updatedProd);
    setEditUnitModal(false);
};

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <AvForm
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v);
                }}
                ref={refContainer}
              >
                <Row>
                  <Col lg={6}>
                    <Label>{props.t("Product")}</Label>
                    <Select
                      ref={refSelectProduct}
                      value={selectedProduct}
                      onChange={(selected) => {
                        handleSelectProduct(selected)
                      }}
                      options={allProducts}
                      classNamePrefix="select2-selection"
                      components={animatedComponents}
                      required
                    />
                  </Col>
                  {selectedProduct?.quantity?.length>0 && (
                    <Col lg={6}>
                    <Label>{props.t("Quantity")}</Label> <br />
                       {formatUnitsForReport(selectedProduct?.quantity) }
                       <Button
                  className="btn btn-success waves-effect waves-light btn-sm ms-5"
                  onClick={() => {
                    setEditUnitModal(!editUnitModal);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
                  </Col>
                  )}
                  <Col lg={6} className="mt-1">
                  <Label>
                      {props.t("Cost Price")}
                      {selectedProduct && " (per " + selectedProduct.unit_for_cost_price + ")"}
                    </Label>
                    <AvField
                      name="cost_price"
                      placeholder={props.t("Enter Cost Price")}
                      type="number"
                      value={Number(selectedProduct?.cost_price || 0)}
                      disabled
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                        required:{value:true,errorMessage: props.t("cost price is required."),
                        }
                      }}
                    />
                  </Col>
                  <Col lg={6}>
                    <Label>
                      {props.t("Selling Price")}
                      {selectedProduct && " (per " + selectedProduct.unit_for_selling_price + ")"}
                    </Label>
                    <AvField
                      name="selling_price"
                      placeholder={props.t("Enter Selling Price")}
                      type="number"
                      value={selectedProduct && selectedProduct.selling_price}
                      //disabled={true}
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                      }}
                    />
                  </Col>
                  {/* <Col lg={6}>
                    <AvField
                      name="expiry_date"
                      label={props.t("Expiry Date") + " *"}
                      placeholder={props.t("Select Expiry Date")}
                      type="date"
                      min={currentDate}
                      required
                      errorMessage="Expiry date cannot be empty"
                    />
                  </Col> */}
                  <Col lg={12}>
                    <hr />
                    <FormGroup className="mb-0 text-center">
                      <div>
                        <Button type="submit" style={{width:"100px"}} color="primary" className="mr-1" disabled={isDisabled}>
                        {isDisabled ? <Spinner size="sm" /> : props.t("Submit")} 
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>

            {/* Add quanity modal  */}
      <EnterQuantityForManualInventory
        isOpen={selectUnitModal}
        toggle={handleToggle}
        onSubmit={handleAddQuantity}
        item={selectedProduct}
      />

 {/* Edit quantity modal  */}
                  <UpdateQuantityForManualInventory
                   isOpen={editUnitModal}
                   toggle={handleToggle}
                   onSubmit={handleUpdateQuantity}
                   item={selectedProduct}
                  />
        </Col>
      </Row>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AddOpeningComp))
);
